var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/heart-outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.765 2c1.6 0 3.1.7 4.2 1.8 1.1-1.15 2.6-1.8 4.2-1.8h.6c2.45.25 4.6 2.15 5.4 4.75 2.1 7-6.9 12.6-9.5 14.5-.2.15-.45.25-.7.25-.25 0-.5-.1-.65-.2-2.6-1.9-11.6-7.5-9.5-14.5.75-2.6 2.9-4.5 5.4-4.75.2-.05.35-.05.55-.05zm0 1h-.45c-2.05.2-3.9 1.85-4.55 4.05-1.75 5.75 5.35 10.75 8.4 12.9.25.2.5.35.7.5.05.05.05.05.1.05s.05 0 .1-.05c.2-.15.45-.3.7-.5 3-2.15 10.15-7.15 8.4-12.9-.65-2.25-2.5-3.85-4.55-4.05h-.45c-1.3 0-2.55.55-3.5 1.5l-.7.7-.7-.7c-.95-.95-2.2-1.5-3.5-1.5z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.44f8cb0a9e30abaf9115fc5514f894f7.svg";
export { ForwardRef as ReactComponent };